// extracted by mini-css-extract-plugin
module.exports = {"noop":"Badge_noop__38O8C","badge":"Badge_badge__5IEnk","bigBadge":"Badge_bigBadge__1W01c","optional":"Badge_optional__1O1W8"};